import { metrics } from "../utils/content";
import "../styles/Metrics.css";

export default function Stats() {
  return (
    <div className="my-4 lg:m-4 relative bg-gray-900">
      <div className="h-80 absolute inset-x-0 bottom-0 xl:top-0 xl:h-full">
        <div className="h-full w-full xl:grid xl:grid-cols-2">
          <div className="h-full xl:relative xl:col-start-2">
            <img
              className="h-full w-full object-cover opacity-25 xl:absolute xl:inset-0"
              src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2830&q=80&sat=-100"
              alt="People working on laptops"
            />
            <div
              aria-hidden="true"
              className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-gray-900 xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r"
            />
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8">
        <div className="relative pt-12 pb-64 sm:pt-24 sm:pb-64 xl:col-start-1 xl:pb-24">
          <h2 className="text-sm font-semibold tracking-wide uppercase">
            <span className="bg-gradient-to-r from-cyan-300 from-indigo-300 to-blue-300 bg-clip-text text-transparent">
              Valuable Metrics
            </span>
          </h2>
          <p className="mt-3 text-3xl font-extrabold text-white">
            Get actionable data that will help grow your business.
          </p>
          <p className="mt-5 text-lg text-gray-300">
            Projects using metrics to analyze and understand about their processes have seen improvements like
          </p>
          <div className="mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2">
            {metrics.map((item) => (
              <p key={item.id}>
                <span className="flex items-center justify-center h-12 w-12 rounded-md bg-white bg-opacity-10 margin-w-auto">
                  <item.icon
                    className="h-6 w-6 text-white"
                    aria-hidden="true"
                  />
                </span>
                <span className="mt-1 block text-base text-gray-300 margin-h-12">
                  <span className="font-medium text-white">
                    {item.emphasis}
                  </span>{" "}
                </span>
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
